module.exports = __webpack_public_path__ + "img/create_btn1.da007e3f.png";